import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const RevenueChart = ({ data, type = 'line', granularity = 'daily' }) => {
  const formatLabel = (item) => {
    switch (granularity) {
      case 'hourly':
        return item.time || item.label || item.date || '';
      case 'daily':
        if (item.dayName && item.day) return `${item.dayName} ${item.day}`;
        return item.label || item.date || '';
      case 'monthly':
        if (item.month && item.year) return `${item.month} ${item.year}`;
        return item.label || item.date || '';
      default:
        return item.label || item.date || '';
    }
  };

  const formatTooltip = (context) => {
    const value = context.parsed.y;
    return `$${value.toLocaleString()}`;
  };

  const chartData = {
    labels: data.map(formatLabel),
    datasets: [
      {
        label: 'Revenue',
        data: data.map((item) => item.revenue),
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor:
          type === 'line'
            ? 'rgba(59, 130, 246, 0.1)'
            : 'rgba(59, 130, 246, 0.8)',
        borderWidth: 3,
        fill: type === 'line',
        tension: 0.4,
        pointBackgroundColor: 'rgb(59, 130, 246)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgb(59, 130, 246)',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          label: formatTooltip,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#6b7280',
          font: {
            size: 12,
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(107, 114, 128, 0.1)',
        },
        ticks: {
          color: '#6b7280',
          font: {
            size: 12,
          },
          callback: function (value) {
            return `$${(value / 1000).toFixed(0)}k`;
          },
        },
      },
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
  };

  const ChartComponent = type === 'line' ? Line : Bar;

  return (
    <div className="h-80">
      <ChartComponent data={chartData} options={options} />
    </div>
  );
};

export default RevenueChart;
